import React, { useState } from 'react';
import T from './theme';
import CollapsibleCard from './CollapsibleCard';
import { extractError } from './utils';

export default function FeedbackCard({ api, setError }) {
  const [storyInput, setStoryInput] = useState('');
  const [storySaved, setStorySaved] = useState(false);

  return (
    <CollapsibleCard title="Feedback" accentColor={T.color.accentFeedback}>
      <p style={{ color: T.color.textMuted }}>
        What would you like in a training app?
      </p>
      <form
        onSubmit={async (e) => {
          e.preventDefault();
          const body = storyInput.trim();
          if (body.length < 3) {
            setError('Write a bit more about what you want.');
            return;
          }
          try {
            await api.post('/me/stories', { body });
            setStoryInput('');
            setStorySaved(true);
            setError(null);
          } catch (err) {
            setError('Failed to save that: ' + extractError(err));
          }
        }}
      >
        <textarea
          value={storyInput}
          onChange={(e) => {
            setStoryInput(e.target.value);
            setStorySaved(false);
          }}
          rows={4}
          placeholder="Recovery after a bad night, race planning, strength, whatever is missing…"
          style={{ width: '100%', boxSizing: 'border-box', marginBottom: 8 }}
        />
        <button type="submit">Send</button>
        {storySaved && <span style={{ marginLeft: 8, color: T.color.textLight }}>Saved. Thank you.</span>}
      </form>
    </CollapsibleCard>
  );
}
